const abbrDaysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const abbrMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

export const monthYearRange = (startDate: string, endDate: string): string => {
	const start = new Date(startDate);
	const end = new Date(endDate);

	const startMonthIndex = getMonth(start);
	const endMonthIndex = getMonth(end);

	const startMonth = months[startMonthIndex];
	const startYear = getYear(start);
	const endMonth = months[endMonthIndex];
	const endYear = getYear(end);

	if (startYear === endYear) {
		if (startMonthIndex === endMonthIndex) {
			return `${startMonth} ${startYear}`;
		}
		return `${startMonth} - ${endMonth} ${startYear}`;
	}

	return `${startMonth} ${startYear} - ${endMonth} ${endYear}`;
};

const getDay = (date: Date, useUtcTime = true): number => {
	if (useUtcTime) {
		return date.getUTCDay();
	}
	return date.getDay();
};

const getMonth = (date: Date, useUtcTime = true): number => {
	if (useUtcTime) {
		return date.getUTCMonth();
	}
	return date.getMonth();
};

const getYear = (date: Date, useUtcTime = true): number => {
	if (useUtcTime) {
		return date.getUTCFullYear();
	}
	return date.getFullYear();
};

export const getDate = (date: Date, useUtcTime = true): number => {
	if (useUtcTime) {
		return date.getUTCDate();
	}
	return date.getDate();
};

export const getDateStr = (date: string, useUtcTime = true): string => {
	const dateNumber: number = getDate(new Date(date), useUtcTime);
	return dateNumber ? dateNumber.toString() : '';
};

export const getDayOfTheWeek = (date: string, useUtcTime = true): string => {
	const dayIndex = getDay(new Date(date), useUtcTime);
	const day = abbrDaysOfWeek[dayIndex];
	return day || '';
};

export const getShortTimeAmPm = (time: string): string => {
	if (!time) {
		return '';
	}

	const [hour, minute] = time.split(':').map(Number);
	const period = hour < 12 ? 'AM' : 'PM';
	const formattedHour = hour % 12 || 12;

	return `${formattedHour}:${minute.toString().padStart(2, '0')} ${period}`;
};

export const getDayMonth = (dateStr: string, useUtcTime = true): string => {
	const monthIndex = getMonth(new Date(dateStr), useUtcTime);
	const date = getDateStr(dateStr, useUtcTime);
	return `${abbrMonths[monthIndex]} ${date}`;
};
